import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDeepinComponent } from './simple-icons-deepin.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDeepinComponent ],
    exports:      [ SimpleIconsDeepinComponent ],
    bootstrap:    []
})
export class SimpleIconsDeepinModule {}
